import {AxiosPromise} from "axios";
import { HttpService } from "@/services/http.services";

export default class GatewayApi {
    public getOneTimeToken = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = 'one-time-token';
        return HttpService.post(url, params, headers);
    }
}
